function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  r: 156.5,
  transform: "matrix(-1 0 0 1 343.5 156.5)",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.5
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 99C0 136.555 30.4446 167 68 167C105.555 167 136 136.555 136 99C136 61.4446 105.555 31 68 31C30.4446 31 0 61.4446 0 99Z",
  fill: "#EC7373",
  fillOpacity: 0.94
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 99C0 136.555 30.4446 167 68 167C105.555 167 136 136.555 136 99C136 61.4446 105.555 31 68 31C30.4446 31 0 61.4446 0 99Z",
  fill: "#5763A2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 60.7986,
  y1: -28.2569,
  x2: 365.473,
  y2: 23.3371,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E16A1E"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#CA68A4"
})));

var SvgFooterBubbles = function SvgFooterBubbles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 500,
    height: 313,
    viewBox: "0 0 500 313",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref3, _ref4), _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFooterBubbles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Footer-bubbles.176d522d.svg";
export { ForwardRef as ReactComponent };